import React from 'react'
import Head from '../../../../layout/head/Head'
import Content from '../../../../layout/content/Content'
import About from './GraphPageComponents/About'
import ChooseUs from './GraphPageComponents/ChooseUs'
import ServiceOffer from './GraphPageComponents/ServiceOffer'
import ImpOfService from './GraphPageComponents/ImpOfService'
import Contact from '../../components/Contact'
import Testimonial from '../components/Testimonial'
import GenericHero from '../components/GenericHero'
import { Icon } from '../../../../components/Component'
import heroimg from '../../../../images/axiom_img/GraphicPage-images/Graphic_Design.jpeg';


const GrapgicsPage = () => {
    return (
        <React.Fragment>
            <Head title="Axiom | Graphics Design"></Head>
            <Content>
                <GenericHero
                    breadcrumbs={
                        <>
                            SERVICES <Icon name={'chevron-right'} /> Creative & Design Services <Icon name={'chevron-right'} /> Graphics Design
                        </>
                    }
                    title="Elevating brand identity through Design: Professional visual storytelling"
                    description="Strategic design, crafting a visual brand identity that resonates"
                    buttonText="Contact Now"
                    buttonLink="/contact"
                    heroImage={heroimg} />
                <About />
                <ChooseUs />
                <ServiceOffer />
                <ImpOfService />
                <Contact />
                <Testimonial />
            </Content>
        </React.Fragment>
    )
}

export default GrapgicsPage
